import { Flex } from "@redotech/redo-web/flex";
import RedoLogoSvg from "@redotech/redo-web/logo.svg";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import * as footerStyles from "./marketplace-footer.module.css";

export const MarketplaceFooter = memo(function MarketplaceFooter() {
  return (
    <footer className={footerStyles.footer}>
      <Flex
        align="center"
        className={footerStyles.container}
        dir="row"
        justify="space-between"
        w="full"
      >
        <Flex align="center" dir="row" gap="md">
          <RedoLogoSvg className={footerStyles.logo} />
          <Text className={footerStyles.copyright} fontSize="xs">
            © {new Date().getFullYear()} Redo. All rights reserved.
          </Text>
        </Flex>
      </Flex>
    </footer>
  );
});
